module.exports = __webpack_public_path__ + "static/media/Al-Ayn.7dd18293.png";